class MobileMenuController {
  constructor() {
    this.drawer = document.querySelector('[data-mobile-menu]');
    this.toggles = Array.from(document.querySelectorAll('[data-menu-toggle]'));
    this.closeButtons = Array.from(document.querySelectorAll('[data-menu-close]'));
    this.header = document.querySelector('[data-header]');
    this.lastTrigger = null;
    this.isOpen = false;
    this.resizeHandler = this.updateDrawerMetrics.bind(this);

    if (!this.drawer || !this.toggles.length) return;

    this.panel = this.drawer.querySelector('.mobile-menu__panel');
    this.bindEvents();
    this.updateDrawerMetrics();
    this.syncExpanded(false);
  }

  bindEvents() {
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (this.isOpen) {
          this.close();
        } else {
          this.open(toggle);
        }
      });
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    window.addEventListener('resize', this.resizeHandler, { passive: true });
    window.addEventListener('orientationchange', this.resizeHandler);
    window.addEventListener('load', this.resizeHandler);
  }

  syncExpanded(state) {
    this.toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
    });
  }

  updateDrawerMetrics() {
    if (!this.drawer) return;

    const fallbackTop = 72;
    let headerBottom = fallbackTop;

    if (this.header) {
      const rect = this.header.getBoundingClientRect();
      headerBottom = Math.max(0, Math.round(rect.bottom));
    }

    this.drawer.style.setProperty('--mobile-menu-top', `${headerBottom}px`);
  }

  open(trigger) {
    this.lastTrigger = trigger || document.activeElement;
    this.updateDrawerMetrics();
    this.drawer.hidden = false;

    requestAnimationFrame(() => {
      this.drawer.classList.add('is-open');
      document.body.classList.add('is-mobile-menu-open');
      document.documentElement.classList.add('is-mobile-menu-open');
      this.isOpen = true;
      this.syncExpanded(true);

      const closeButton = this.drawer.querySelector('.mobile-menu__close');
      if (closeButton) closeButton.focus();
    });
  }

  close() {
    if (!this.isOpen) return;

    this.drawer.classList.remove('is-open');
    document.body.classList.remove('is-mobile-menu-open');
    document.documentElement.classList.remove('is-mobile-menu-open');
    this.isOpen = false;
    this.syncExpanded(false);

    window.setTimeout(() => {
      this.drawer.hidden = true;
      if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
        this.lastTrigger.focus();
      }
    }, 260);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MobileMenuController();
});